import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';

import { FormErrorMessage } from 'src/common/FormErrorMessage';
import { useEditInvoiceById } from 'src/features/billing/invoices/management/useEditInvoice';

interface TripSubscriptionFormErrorProps {
  error?: string | null;
  formattedError?: Record<string, string> | null;
}
export function TripSubscriptionFormError({
  error,
  formattedError,
}: TripSubscriptionFormErrorProps) {
  if (error) {
    return <FormErrorMessage>{error}</FormErrorMessage>;
  }

  if (formattedError) {
    return <InvoicedTripError formattedError={formattedError} />;
  }

  return null;
}

interface InvoicedTripErrorProps {
  formattedError: Record<string, string>;
}
function InvoicedTripError({ formattedError }: InvoicedTripErrorProps) {
  const handleEditInvoice = useEditInvoiceById();

  const handleEditInvoiceClick = useCallback(() => {
    handleEditInvoice(formattedError.invoice_id);
  }, [handleEditInvoice, formattedError.invoice_id]);

  return (
    <FormErrorMessage>
      <div className="flex flex-row items-center justify-between">
        {formattedError.detail}
        <Button
          onClick={handleEditInvoiceClick}
          dataTestId="edit-invoice-button"
        >
          Edit Invoice: {formattedError.invoice_number}
        </Button>
      </div>
    </FormErrorMessage>
  );
}
